module.exports = __webpack_public_path__ + "img/editVector.31caaff4.svg";